import React from "react";
import './App.css';
import Navbar from './Components/Navbar';
import Section from './Components/Section';
import Product from './Components/Product';
import Promo from './Components/Promo';
import About from './Components/About';
import Contact from './Components/Contact';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';





function App() {
  return (
    <>
   
    <Router>
       <div>
       <Navbar/> 
       
       <Switch>
          <Route exact path="/product">
          <Product />
          </Route>
          <Route  exact path="/Promo">
          <Promo/>
          </Route>
          <Route exact path="/">
              <Section/> 
          </Route>
          <Route exact path="/About" > 
          <About/>
         
          </Route>
          <Route exact path="/Contact">
            <Contact/>
          </Route>
          
        </Switch>
       </div>
       
    </Router>
   
    </>
   




  );
}

export default App;
